export default class User {
  constructor(username, name, password) {
    this.username = username;
    this.name = name;
    this.password = password;
  }
}
